/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateContactRequest
 */
export interface UpdateContactRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateContactRequest
     */
    contactType?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactRequest
     */
    jobTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContactRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the UpdateContactRequest interface.
 */
export function instanceOfUpdateContactRequest(value: object): value is UpdateContactRequest {
    return true;
}

export function UpdateContactRequestFromJSON(json: any): UpdateContactRequest {
    return UpdateContactRequestFromJSONTyped(json, false);
}

export function UpdateContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contactType': json['contactType'] == null ? undefined : json['contactType'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'jobTitle': json['jobTitle'] == null ? undefined : json['jobTitle'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateContactRequestToJSON(json: any): UpdateContactRequest {
    return UpdateContactRequestToJSONTyped(json, false);
}

export function UpdateContactRequestToJSONTyped(value?: UpdateContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactType': value['contactType'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phone': value['phone'],
        'jobTitle': value['jobTitle'],
        'notes': value['notes'],
    };
}

